<template>
  <div>
    <v-container v-if="role">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-banner elevation="2">
            {{ roleText }}
            <template v-slot:actions>
              <v-btn text color="indigo darken-3" to="/admin">
                เข้าสู่หน้า Admin
              </v-btn>
            </template>
          </v-banner>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
    <v-container class="pb-0 text-center">
      <h1 v-if="!rootApi" class="mx-auto my-0">Loading...</h1>
      <p v-if="greetingText" class="mx-auto my-0">{{ greetingText }}</p>
    </v-container>
    <ThankYou></ThankYou>
    <RoleResults v-if="rootApi" :student="rootApi.user"></RoleResults>
    <Cadaver v-if="cadaver" :cadaver="cadaver"></Cadaver>
    <v-container class="text-center">
      <p class="mx-auto">ด้วย ❤ ฝ่ายข้อมูล - {{ team }}</p>
      <p class="mx-auto">แก้ไขข้อมูล: cadaver@docchula.com</p>
    </v-container>
  </div>
</template>

<script>
import RoleResults from "./RoleResults";
import Cadaver from "./Cadaver/index";
import ThankYou from "./ThankYou";

export default {
  name: "Dashboard",
  props: ["rootApi"],
  components: { RoleResults, Cadaver, ThankYou },
  computed: {
    team() {
      const array = ["ไม้", "เบลล์", "ก้าว", "เอื้อย"];
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array.join(" ");
    },
    greetingText() {
      if (this.rootApi) {
        const user = this.rootApi.user;
        if (user.firstContact) {
          return `${user.title}${user.name} ${user.surname} ได้รับมอบหมายให้ติดต่อญาติอาจารย์ใหญ่ ${user.firstContact}`;
        }
        return `${user.title}${user.name} ${user.surname} ไม่ได้รับมอบหมายให้ติดต่อญาติอาจารย์ใหญ่`;
      }
      return null;
    },
    cadaver() {
      if (this.rootApi) {
        return this.rootApi.cadaver || null;
      }
      return null;
    },
    role() {
      if (this.rootApi && this.rootApi.user.role) {
        return true;
      }
      return false;
    },
    roleText() {
      if (this.rootApi && this.rootApi.user.role) {
        const user = this.rootApi.user;
        return `${user.title}${user.name} ${user.surname} เป็นหนึ่งในคณะทำงาน`;
      }
      return null;
    },
  },
  mounted() {
    /* global amplitude */
    amplitude.getInstance().logEvent("view_dashboard");
  },
};
</script>
